<template>
  <div class="article-detail">
    <h3>如何查询推广的业绩？</h3>
    <p>
      登录
      <a href="https://saas.tuielf.com/supplier" target="_blank">
        https://saas.tuielf.com/supplier
      </a>
      ，找到推广位信息，选择相应的推广位和日期即可查看。
    </p>

    <p>
      <img
        v-viewer
        style="width: 600px"
        src="../../assets/supplier2.png"
        alt=""
      />
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
h3 {
  font-size: 16px;
  font-weight: 700;
}
p {
  margin: 10px 0;
  font-size: 16px;
}

a {
  font-size: 16px;
  color: #4080ff;

  &:hover {
    text-decoration: underline;
  }
}

img {
  max-width: 100%;
}
</style>
